<template>
  <div class="layout layout--full min-h-screen flex flex-col">
    <div class="layout__header-wrapper">
      <slot name="layout__header">
        <PushAlert />
        <OHeaderMobile v-if="isMobile" class="block">
          <slot slot="headerBefore" name="headerBefore"></slot>
        </OHeaderMobile>
        <OHeader v-else class="block"></OHeader>
      </slot>
    </div>
    <GoogleSignIn v-if="!isLoggedIn" />
    <div
      class="layout__main flex-1 flex flex-col"
      :class="{
        'pt-[100px]': !isMobile,
      }"
    >
      <slot name="page__actions_container">
        <PageActions v-if="!isMobile" :is-subpage="isSubpage">
          <slot slot="page__actions" name="page__actions"></slot>
        </PageActions>
      </slot>
      <slot name="video__streaming__section"></slot>
      <slot>
        <div>Content</div>
      </slot>
      <PageUpButton v-if="!isMobile" />
    </div>
    <div class="layout__footer">
      <slot name="footer">
        <OFooter v-if="!hideFooter" />
      </slot>
    </div>
    <CustomInterstitial />
  </div>
</template>

<script>
import { computed, defineComponent, onMounted, useRoute, useContext } from '@nuxtjs/composition-api';
import OFooter from '~/modules/common/components/app/footer/OFooter';
import CustomInterstitial from '~/modules/ads/components/CustomInterstitial';
import { useDevice } from '~/composables/useDevice';
import { useCookieConsent } from '~/composables/useCookieConsent';
import { useMailVerify } from '~/composables/useMailVerify';
import { IS_ONEDIO } from '~/constants/config';
import { useWebSocket } from '~/composables/useWebSocket';
import { useAuth } from '~/modules/auth/state/useAuth';
export default defineComponent({
  components: {
    PageActions: () => import(/* webpackChunkName: "PageActions" */ '~/modules/common/components/app/layout/PageActions'),
    PageUpButton: () => import(/* webpackChunkName: "PageUpButton" */ '~/modules/common/components/app/layout/PageUpButton'),
    PushAlert: () => import(/* webpackChunkName: "PushAlert" */ '~/modules/webpush/component/PushAlert'),
    OFooter,
    CustomInterstitial,
    OHeader: () => import(/* webpackChunkName: "OHeader" */ '~/modules/common/components/app/header/OHeader'),
    OHeaderMobile: () => import(/* webpackChunkName: "OHeaderMobile" */ '~/modules/common/components/app/header/OHeaderMobile'),
    GoogleSignIn: () => import(/* webpackChunkName: "GoogleSignIn" */ '~/modules/auth/components/GoogleSignIn'),
  },
  props: {
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { isMobile } = useDevice();
    const { value: route } = useRoute();
    const { getCookieConsent, showCookieModal } = useCookieConsent();
    const { getMailVerify, showVerifyModal } = useMailVerify();
    const { $oet } = useContext();
    const { Init } = useWebSocket();
    const { user, isLoggedIn } = useAuth();

    const isSubpage = computed(() => route.path.length !== 1);
    onMounted(async () => {
      // cookie consent
      if (!getCookieConsent() && IS_ONEDIO) {
        showCookieModal();
      }
      // email verify
      if (!getMailVerify()) {
        showVerifyModal();
      }
      // init websocket
      const clientIdChangeCallbackFn = async (clientOldId, clientNewId) => {
        if (clientOldId !== clientNewId) {
          await $oet.sendPushNotificationPlatformInformations({
            userId: user.value?._id,
            notificationTargetValue: clientNewId,
            externalPlatform: 'chatty',
            notificationTargetType: 'chattyId',
          });
        }
      };
      await Init({ cidChangeCallback: clientIdChangeCallbackFn });
    });

    return { isMobile, isSubpage, isLoggedIn };
  },
});
</script>

<style></style>
